module.exports = __webpack_public_path__ + "img/logo.82c5c45e.png";